export default [
  { text: 'Обязателен', value: 'is_required' },
  { text: '', value: 'actions', align: 'right', width: '75px' },
]
